/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Viewer_Pit2_TInputs */

const en_viewer_pit2_t = /** @type {(inputs: Viewer_Pit2_TInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Duplicate keys collapse before the tree is built`)
};

const ko_viewer_pit2_t = /** @type {(inputs: Viewer_Pit2_TInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`중복 키는 트리가 만들어지기 전에 합쳐집니다`)
};

const ja_viewer_pit2_t = /** @type {(inputs: Viewer_Pit2_TInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`重複キーはツリーが作られる前にまとめられます`)
};

/**
* | output |
* | --- |
* | "Duplicate keys collapse before the tree is built" |
*
* @param {Viewer_Pit2_TInputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const viewer_pit2_t = /** @type {((inputs?: Viewer_Pit2_TInputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Viewer_Pit2_TInputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_viewer_pit2_t(inputs)
	if (locale === "ko") return ko_viewer_pit2_t(inputs)
	return ja_viewer_pit2_t(inputs)
});